export default "__VITE_ASSET__BCf8VRD6__"